import { z } from 'zod';
import { apiEnvelope } from '../envelope';

export type I18nNamespaceValue = string | { [key: string]: I18nNamespaceValue };

export const i18nNamespaceValueSchema: z.ZodType<I18nNamespaceValue> = z.lazy(() =>
  z.union([z.string(), z.record(z.string(), i18nNamespaceValueSchema)]),
);

export const i18nNamespaceSchema = z.record(z.string(), i18nNamespaceValueSchema);
export const i18nCatalogSchema = z.record(z.string(), i18nNamespaceSchema);
export const i18nCatalogResponseSchema = apiEnvelope(i18nCatalogSchema);

export type I18nCatalog = z.infer<typeof i18nCatalogSchema>;
